module.exports = __webpack_public_path__ + "assets/img/index2.028aae36.png";